import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { cx, ui } from '@wp-g2/styles';
import React from 'react';
import { Radio } from 'reakit';
import * as styles from './SegmentedControl.styles';
var ButtonContentView = styles.ButtonContentView,
    ButtonView = styles.ButtonView,
    LabelPlaceholderView = styles.LabelPlaceholderView,
    LabelView = styles.LabelView,
    SeparatorView = styles.SeparatorView;

function SegmentedControlButton(_ref) {
  var className = _ref.className,
      forwardedRef = _ref.forwardedRef,
      _ref$isBlock = _ref.isBlock,
      isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock,
      label = _ref.label,
      showSeparator = _ref.showSeparator,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["className", "forwardedRef", "isBlock", "label", "showSeparator", "value"]);

  var isActive = props.state === value;
  var labelViewClasses = cx(isBlock && styles.labelBlock);
  var classes = cx(isActive && styles.buttonActive, className);
  return /*#__PURE__*/React.createElement(LabelView, Object.assign({
    className: labelViewClasses,
    "data-active": isActive
  }, ui.$('SegmentedControlButtonLabel')), /*#__PURE__*/React.createElement(Radio, Object.assign({}, props, {
    as: ButtonView,
    className: classes,
    "data-value": value,
    ref: forwardedRef,
    value: value
  }), /*#__PURE__*/React.createElement(ButtonContentView, ui.$('SegmentedControlButtonContent'), label), /*#__PURE__*/React.createElement(LabelPlaceholderView, Object.assign({
    "aria-hidden": true
  }, ui.$('SegmentedControlButtonContentPlaceholder')), label)), /*#__PURE__*/React.createElement(SegmentedControlSeparator, {
    isActive: !showSeparator
  }));
}

var SegmentedControlSeparator = /*#__PURE__*/React.memo(function (_ref2) {
  var isActive = _ref2.isActive;
  var classes = cx(isActive && styles.separatorActive);
  return /*#__PURE__*/React.createElement(SeparatorView, Object.assign({
    "aria-hidden": true,
    className: classes
  }, ui.$('SegmentedControlButtonSeparator')));
});
export default /*#__PURE__*/React.memo(SegmentedControlButton);